import { render, staticRenderFns } from "./SOA.vue?vue&type=template&id=238d05f4&scoped=true&"
import script from "./SOA.vue?vue&type=script&lang=js&"
export * from "./SOA.vue?vue&type=script&lang=js&"
import style0 from "./SOA.vue?vue&type=style&index=0&id=238d05f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d05f4",
  null
  
)

export default component.exports